<template>
  <div>
    <slot v-if="isSigned"></slot>
    <slot v-else name="spinner"></slot>
  </div>
</template>

<style lang="scss">

</style>

<script setup>
import axios from "axios";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { route } from "ziggy";

const props = defineProps({
    quoteKey: { type: String, required: true },
    pollingInterval: { type: Number, required: true },
});

const isSigned = ref(false);
const interval = ref(null);

async function checkSignature() {
    try {
        const response = await axios.get(
            route("quotes.signatureCount", props.quoteKey)
        );

        if (response.data.count > 0) {
            isSigned.value = true;
            stopPolling();
        }
    } catch (error) {
        console.warn("Failed to check quote signature status.", error);
    }
}

function stopPolling() {
    clearInterval(interval.value);
    interval.value = null;
}

onMounted(() => {
    interval.value = setInterval(() => {
        checkSignature();
    }, props.pollingInterval);
});

onBeforeUnmount(stopPolling);
</script>
